import React, { Fragment } from 'react';
import Image from 'react-bootstrap/Image'
import '../../assets/css/scss/component/_leagueMatch.scss'

export default function LeagueMatch() {
    return (
        <Fragment>
            <div className="league-match text-center">
                <h3 className="font-16 bold mb-4 mb-xl-3">Europe, WC Qualification</h3>
                <div className="d-flex align-items-center justify-content-between">
                    <div className="flag-div">
                        <Image src="/assets/images/logo-2.png" alt="europe" fluid />
                    </div>
                    <div className="vs-div">
                        <h4 className="h3 bold">VS</h4>
                    </div>
                    <div className="flag-div">
                        <Image src="/assets/images/logo-1.png" alt="europe" fluid />
                    </div>
                </div>
            </div>
        </Fragment>
    )
}
